import React, { useState } from "react";
import { adjustStudentPointsAPI } from "../../../reward/rewardAPI";

export const POINT_ADD_COLOR = "#16A34A";
export const POINT_SUBTRACT_COLOR = "#E5383B";

// 포인트 추가(초록) · 감소(빨강). 사유는 아이 포인트 내역에 그대로 보인다
const StudentPointModal = ({ student, balance, mode, onDone, onClose }) => {
  const isAdd = mode === "add";
  const color = isAdd ? POINT_ADD_COLOR : POINT_SUBTRACT_COLOR;
  const [amount, setAmount] = useState("");
  const [reason, setReason] = useState("");
  const [isSaving, setIsSaving] = useState(false);

  const save = async () => {
    const value = parseInt(String(amount).replace(/[^0-9]/g, ""), 10);
    if (!value) return alert("포인트를 적어 주세요.");
    if (!reason.trim()) return alert("사유를 적어 주세요.");
    setIsSaving(true);
    try {
      const result = await adjustStudentPointsAPI(student.id, isAdd ? value : -value, reason.trim());
      onDone(result.balance);
    } catch (error) {
      alert(error?.response?.data?.error || "저장하지 못했습니다.");
      setIsSaving(false);
    }
  };

  return (
    <div style={backdropStyle} onClick={onClose}>
      <div style={sheetStyle} onClick={(event) => event.stopPropagation()}>
        <div style={{ fontSize: "1.05rem", fontWeight: 800, color: "#0E141B" }}>
          {student.name} <span style={{ color }}>{isAdd ? "포인트 추가" : "포인트 감소"}</span>
        </div>
        <div style={{ marginTop: "4px", fontSize: "0.85rem", color: "#5B6670" }}>지금 {balance.toLocaleString()}P</div>
        <label style={labelStyle}>포인트</label>
        <div style={{ position: "relative" }}>
          <input
            autoFocus
            inputMode="numeric"
            value={amount}
            onChange={(event) => setAmount(event.target.value.replace(/[^0-9]/g, ""))}
            style={{ ...inputStyle, paddingRight: "34px", borderColor: color }}
          />
          <span style={{ position: "absolute", right: "12px", top: "50%", transform: "translateY(-50%)", color: "#5B6670" }}>P</span>
        </div>
        <label style={labelStyle}>사유</label>
        <input
          value={reason}
          maxLength={100}
          onChange={(event) => setReason(event.target.value)}
          onKeyDown={(event) => event.key === "Enter" && !event.nativeEvent.isComposing && save()}
          style={inputStyle}
        />
        <div style={{ display: "flex", gap: "8px", marginTop: "18px" }}>
          <button onClick={onClose} style={{ ...buttonStyle, background: "#F4F8F7", color: "#3A434E" }}>
            취소
          </button>
          <button onClick={save} disabled={isSaving} style={{ ...buttonStyle, background: color, color: "#fff" }}>
            {isAdd ? "추가" : "감소"}
          </button>
        </div>
      </div>
    </div>
  );
};

const backdropStyle = {
  position: "fixed", inset: 0, background: "rgba(14,20,27,.45)", display: "flex",
  alignItems: "center", justifyContent: "center", zIndex: 10000, padding: "16px",
};
const sheetStyle = {
  width: "100%", maxWidth: "340px", background: "#fff", borderRadius: "18px", padding: "22px 20px 18px",
  boxShadow: "0 20px 50px rgba(14,20,27,.3)",
};
const labelStyle = { display: "block", marginTop: "14px", marginBottom: "6px", fontSize: "0.82rem", fontWeight: 700, color: "#3A434E" };
const inputStyle = {
  width: "100%", boxSizing: "border-box", height: "42px", border: "1px solid #E6EDEC", borderRadius: "10px",
  padding: "0 12px", fontSize: "0.95rem", outline: "none",
};
const buttonStyle = { flex: 1, height: "42px", border: "none", borderRadius: "10px", fontWeight: 800, fontSize: "0.92rem", cursor: "pointer" };

export default StudentPointModal;
